import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, BookmarkIcon, Share2Icon, CopyIcon, ThumbsUpIcon, FlagIcon } from 'lucide-react';
import { toast } from 'sonner';
import { schools } from '../data/mockSchools';
const tabs = ['基础信息', '申请要求', '专业设置', '录取案例', '用户评价'] as const;
export function SchoolDetail() {
  const {
    id
  } = useParams();
  const nav = useNavigate();
  const s = schools.find(x => x.id === id) || schools[0];
  const [tab, setTab] = useState<(typeof tabs)[number]>('基础信息');
  const [saved, setSaved] = useState(false);
  return <div className="bg-slate-50 min-h-screen pb-20" data-id="element-652">
      <div className="relative h-48" data-id="element-653">
        <img src={s.photo} alt="" className="w-full h-full object-cover" data-id="element-654" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/65 to-transparent" data-id="element-655" />
        <button onClick={() => nav(-1)} className="absolute top-3 left-3 w-9 h-9 rounded-full bg-black/40 text-white flex items-center justify-center" aria-label="返回" data-id="element-656">
          <ChevronLeftIcon size={20} data-id="element-657" />
        </button>
        <div className="absolute top-3 right-3 flex gap-2" data-id="element-658">
          <button onClick={() => {
          setSaved(!saved);
          toast(!saved ? '已收藏' : '已取消收藏');
        }} className="w-9 h-9 rounded-full bg-black/40 text-white flex items-center justify-center" aria-label="收藏" data-id="element-659">
            <BookmarkIcon size={18} fill={saved ? 'white' : 'none'} data-id="element-660" />
          </button>
          <button onClick={() => toast('已复制分享链接')} className="w-9 h-9 rounded-full bg-black/40 text-white flex items-center justify-center" aria-label="分享" data-id="element-661">
            <Share2Icon size={18} data-id="element-662" />
          </button>
        </div>
        <div className="absolute bottom-3 left-4 text-white" data-id="element-663">
          <div className="text-2xl font-bold" data-id="element-664">{s.cn}</div>
          <div className="text-xs opacity-90" data-id="element-665">{s.en}</div>
          <div className="text-xs opacity-90 mt-1" data-id="element-666">
            {s.flag} {s.country} · {s.city} · QS #{s.rank}
          </div>
        </div>
      </div>

      <div className="bg-white border-b border-slate-100 sticky top-0 z-10" data-id="element-667">
        <div className="flex" data-id="element-668">
          {tabs.map(t => <button key={t} onClick={() => setTab(t)} className={`flex-1 py-3 text-sm whitespace-nowrap relative ${tab === t ? 'text-blue-600 font-bold' : 'text-slate-600'}`} data-id="element-669">
              {t}
              {tab === t && <motion.div layoutId="sd-tab" className="absolute bottom-0 left-1/4 right-1/4 h-0.5 bg-blue-600 rounded" data-id="element-670" />}
            </button>)}
        </div>
      </div>

      <AnimatePresence mode="wait" data-id="element-671">
        <motion.div key={tab} initial={{
        opacity: 0,
        x: 12
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -12
      }} transition={{
        duration: 0.2
      }} className="p-3 space-y-3" data-id="element-672">
          {tab === '基础信息' && <BasicInfo s={s} data-id="element-673" />}
          {tab === '申请要求' && <Requirements data-id="element-674" />}
          {tab === '专业设置' && <Majors data-id="element-675" />}
          {tab === '录取案例' && <Cases data-id="element-676" />}
          {tab === '用户评价' && <Reviews data-id="element-677" />}
        </motion.div>
      </AnimatePresence>
    </div>;
}
function Card({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="bg-white rounded-2xl p-4" data-id="element-678">
      <div className="font-bold text-slate-800 mb-2 flex items-center gap-2" data-id="element-679">
        <span className="w-1 h-4 bg-blue-500 rounded" data-id="element-680" />
        {title}
      </div>
      <div className="text-sm text-slate-600 leading-relaxed" data-id="element-681">{children}</div>
    </div>;
}
function BasicInfo({
  s
}: {
  s: any;
}) {
  return <>
      <Card title="学校介绍" data-id="element-682">
        {s.cn}（{s.en}）位于{s.country}
        {s.city}，QS世界排名第{s.rank}
        位。学校以前沿科研、卓越教学和多元文化闻名。
      </Card>
      <Card title="排名 & 学制 & 学费" data-id="element-683">
        <div className="grid grid-cols-3 gap-2 text-center" data-id="element-684">
          <Stat k="QS排名" v={`#${s.rank}`} data-id="element-685" />
          <Stat k="软科" v={`#${s.rank + 2}`} data-id="element-686" />
          <Stat k="学制" v="1-2 年" data-id="element-687" />
          <Stat k="学费" v="£35k+" data-id="element-688" />
          <Stat k="录取率" v="12%" data-id="element-689" />
          <Stat k="就业率" v="95%" data-id="element-690" />
        </div>
      </Card>
      <Card title="优势专业" data-id="element-691">
        计算机科学、人工智能、金融工程、机械工程、商业分析
      </Card>
    </>;
}
function Stat({
  k,
  v
}: {
  k: string;
  v: string;
}) {
  return <div className="bg-blue-50 rounded-lg py-2" data-id="element-692">
      <div className="text-blue-600 font-bold" data-id="element-693">{v}</div>
      <div className="text-[11px] text-slate-500 mt-0.5" data-id="element-694">{k}</div>
    </div>;
}
function Requirements() {
  const reqs = [{
    k: 'GPA',
    v: '本科均分 85+ / GPA 3.5+',
    highlight: true
  }, {
    k: '语言成绩',
    v: '雅思 7.0（小分 6.5+）/ 托福 100+',
    highlight: true
  }, {
    k: '标化要求',
    v: 'GRE 320+ / GMAT 700+（部分专业）',
    highlight: true
  }];
  return <>
      {reqs.map(r => <div key={r.k} className="bg-white rounded-2xl p-4 flex justify-between items-start gap-3" data-id="element-695">
          <div className="text-sm font-semibold text-slate-700 w-20 shrink-0" data-id="element-696">
            {r.k}
          </div>
          <div className={`flex-1 text-sm ${r.highlight ? 'text-blue-700 font-semibold' : 'text-slate-600'}`} data-id="element-697">
            {r.v}
          </div>
        </div>)}
      <div className="bg-white rounded-2xl p-4" data-id="element-698">
        <div className="flex items-center justify-between" data-id="element-699">
          <div data-id="element-700">
            <div className="text-sm font-semibold text-slate-700" data-id="element-701">
              申请截止日期
            </div>
            <div className="text-base font-bold text-rose-600 mt-1" data-id="element-702">
              2026 年 1 月 15 日
            </div>
          </div>
          <button onClick={() => toast.success('已复制截止日期到日历')} className="text-xs bg-blue-600 text-white px-3 py-1.5 rounded-full flex items-center gap-1" data-id="element-703">
            <CopyIcon size={12} data-id="element-704" /> 复制到日历
          </button>
        </div>
      </div>
    </>;
}
function Majors() {
  const majors = [{
    name: '计算机科学',
    rank: 1,
    desc: '全球顶尖，AI研究实力雄厚，与谷歌、微软等企业有深度合作。'
  }, {
    name: '人工智能',
    rank: 2,
    desc: '与计算机科学紧密相关，强调算法创新和实际应用。'
  }, {
    name: '金融工程',
    rank: 3,
    desc: '结合金融学与数学，培养量化投资和风险管理人才。'
  }, {
    name: '机械工程',
    rank: 4,
    desc: '注重工程实践，与制造业企业有广泛合作。'
  }, {
    name: '商业分析',
    rank: 5,
    desc: '数据驱动决策，培养商业洞察力和数据分析能力。'
  }];
  return <>
      {majors.map(m => <Card key={m.name} title={m.name} data-id="element-705">
          <div className="text-sm text-slate-600 leading-relaxed" data-id="element-706">
            全球排名 {m.rank}，{m.desc}
          </div>
        </Card>)}
    </>;
}
function Cases() {
  const nav = useNavigate();
  return <>
      {[{
      id: 'c1',
      name: '陈同学',
      bg: '985 GPA 3.8 雅思 7.5'
    }, {
      id: 'c2',
      name: '王同学',
      bg: '211 GPA 3.6 托福 105'
    }, {
      id: 'c3',
      name: '李同学',
      bg: '海本 GPA 3.7 雅思 7.0'
    }].map(c => <button key={c.id} onClick={() => nav(`/community/cases/${c.id}`)} className="w-full bg-white rounded-2xl p-4 text-left active:bg-slate-50" data-id="element-707">
          <div className="font-bold text-slate-800" data-id="element-708">{c.name} · 成功录取</div>
          <div className="text-xs text-slate-500 mt-1" data-id="element-709">{c.bg}</div>
        </button>)}
    </>;
}
function Reviews() {
  const initial = [{
    id: 'r1',
    u: '林同学',
    tag: '在读',
    c: '校园环境一流，教授非常 nice，课程压力大但收获满满。',
    likes: 23
  }, {
    id: 'r2',
    u: '王同学',
    tag: '已申请',
    c: '生活成本偏高，但教学资源真的顶尖。',
    likes: 18
  }, {
    id: 'r3',
    u: '张同学',
    tag: '在读',
    c: '中国学生比例适中，社交圈很容易拓展。',
    likes: 12
  }];
  const [data, setData] = useState(initial);
  const [liked, setLiked] = useState<Set<string>>(new Set());
  const like = (id: string) => {
    if (liked.has(id)) return;
    const ns = new Set(liked);
    ns.add(id);
    setLiked(ns);
    setData(data.map(d => d.id === id ? {
      ...d,
      likes: d.likes + 1
    } : d));
  };
  return <>
      {data.map(r => <div key={r.id} className="bg-white rounded-2xl p-4" data-id="element-710">
          <div className="flex items-center gap-2 mb-1" data-id="element-711">
            <span className="font-bold text-slate-800 text-sm" data-id="element-712">{r.u}</span>
            <span className="text-[10px] bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded" data-id="element-713">
              {r.tag}
            </span>
          </div>
          <p className="text-sm text-slate-600 leading-relaxed" data-id="element-714">{r.c}</p>
          <div className="flex items-center gap-3 mt-2 text-xs text-slate-500" data-id="element-715">
            <button onClick={() => like(r.id)} className={`flex items-center gap-1 ${liked.has(r.id) ? 'text-blue-600' : ''}`} data-id="element-716">
              <ThumbsUpIcon size={13} data-id="element-717" /> {r.likes}
            </button>
            <button onClick={() => toast('已举报，我们会尽快处理')} className="flex items-center gap-1" data-id="element-718">
              <FlagIcon size={13} data-id="element-719" /> 举报
            </button>
          </div>
        </div>)}
    </>;
}